import { reactive, toRefs } from 'vue'
import OSM from '@api/osm'
import Mapbox from '@mapbox/mapbox-sdk'
import GeocodingService from '@mapbox/mapbox-sdk/services/geocoding'

export const osm = OSM 

export const mapbox = Mapbox({ 
  accessToken: process.env.APP_MAPBOX_TOKEN,
})

export const geocoding = GeocodingService(mapbox)

export default function () {
  const state = reactive({
    results: [],
    loading: false,
  })

  async function getAddressFromCenter (geocode) {
    state.loading = true 

    let result = null

    try {
      const { address } = await OSM.getFromCenter(geocode)

      result = address
    } catch (error) {
      console.error('Impossible de récupérer l\'adresse', { error })

      return Promise.reject({
        message: 'Impossible de récupérer l\'adresse'
      })
    }

    state.loading = false

    return result
  }

  async function getAddresses (query = {}) {
    if (!query.search || !query.search?.trim()) {
      return Promise.reject({
        message: 'L\'adresse ne peut pas être vide'
      })
    }

    const params = Object.assign({
      countries: null,
      types: ['address', 'place', 'postcode', 'locality', 'neighborhood'],
      limit: 5,
    }, query)

    state.loading = true 

    try {
      // const { body } = await geocoding.forwardGeocode({
      //   query: params.search,
      //   countries: params.countries,
      //   types: params.types,
      //   language: ['fr'],
      //   limit: params.limit,
      // }).send()
      
      // state.results = body.features
    } catch (error) {
      console.error('Impossible de récupérer l\'adresse', { error })

      return Promise.reject({
        message: 'Impossible de récupérer l\'adresse'
      })
    }

    state.loading = false

    return state.results
  }

  return {
    ...toRefs(state),
    getAddresses,
    getAddressFromCenter,
  }
}